export enum FontSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}
export enum VerticalAlignment {
  TOP = 'top',
  CENTER = 'center',
}
export interface CommonErrorScreenProps {
  title?: string;
  description?: string;
  buttonCTA?: () => void;
  buttonText?: string;
  imageSrc?: string;
  fontSize?: FontSize;
  verticalAlignment?: VerticalAlignment;
}
